import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    const defaultState = {
      formationRegistraionForm: {}
    };

    super('registration', defaultState);
    this.defaultState = defaultState;
  }

  async setupEvents() {
    this.on(constants.EVENTS.REGISTRATION.OPEN, ({ level } = {}) => {
      console.log('🚀 ~ Store ~ setupEvents ~ level:', level);
      this.state.formationRegistraionForm = { level: level || '' };
    });
  }
}

export default Store;
